import React, { useState, useEffect } from 'react';
import {
  withRouter,
  Redirect,
  useHistory,
  useLocation,
} from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import {
  combineValidators,
  isRequired,
  createValidator,
  composeValidators,
  hasLengthGreaterThan,
} from 'revalidate';
import { reduxForm, Field, reset } from 'redux-form';
import { resetPasswordAuth } from './redux/authApi';
import LoginTextInput from '../common/form/LoginTextInput';
import BackToLogin from './part/BackToLogin';
import BodyAuth from './part/BodyAuth';
import { useWindowSize } from '../common/helpers/sizeHelper';
import { toastr } from 'react-redux-toastr';
const jwtDecode = require('jwt-decode');

let newPassword;
const handleOnFormChange = (newValues, dispatch, props, previousValues) => {
  const { newPass: newNewPass } = newValues;
  newPassword = newNewPass;
};

const isPassEqual = createValidator(
  (message) => (value) => {
    if (value && value !== newPassword) {
      return message;
    }
  },
  'Password tidak sama!'
);

const isAlphaNum = createValidator(
  (message) => (value) => {
    if (value && !value.match(/^[0-9a-z]+$/)) {
      return message;
    }
  },
  'Password karakter harus huruf atau angka'
);

function mapState(state) {
  return {
    auth: state.auth,
    loading: state.async.loading,
  };
}

const actions = {
  resetPasswordAuth,
};

const validate = combineValidators({
  newPass: composeValidators(
    isRequired({ message: 'Password baru harus diisi' }),
    hasLengthGreaterThan(3)({
      message: 'Password harus memiliki paling sedikit 4 karakter',
    }),
    isAlphaNum
  )(),
  confirmPass: composeValidators(
    isRequired({ message: 'Konfirmasi password harus diisi' }),
    isPassEqual
  )(),
});

function ResetPassword({
  resetPasswordAuth,
  handleSubmit,
  auth,
  error,
  invalid,
  loading,
  pristine,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');
  const tokenDecode = jwtDecode(token);
  const expiresIn = tokenDecode.exp * 1000;
  const username = queryParams.get('username');

  const [isExpired, setIsExpired] = useState(false);
  const [notif, setNotif] = useState(false);

  useEffect(() => {
    let checkExpired = setInterval(() => {
      if (Date.now() < expiresIn) {
        setIsExpired(false);
      } else {
        setIsExpired(true);
      }
    }, 100);

    return () => clearInterval(checkExpired);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpired]);

  const handleResetPassword = async (values) => {
    if (isExpired) {
      return toastr.warning(
        'Peringatan',
        'Link ini telah expired, lakukan request reset password kembali!'
      );
    }
    let newValues = { username, token, password: values.newPass };
    let res = await resetPasswordAuth(history, newValues);
    if (res === 'success') {
      setNotif(true);
      dispatch(reset('formResetPassword'));
    }
  };

  let windowSize = useWindowSize();

  const handleBackToLogin = () => {
    return history.push('/');
  };

  if (auth && auth.isAuth && auth.registerParents)
    return <Redirect to='/register-2' />;
  if (auth && auth.isAuth && !auth.registerParents)
    return <Redirect to='/dashboard' />;

  return (
    <BodyAuth
      title={''}
      width={
        windowSize[0] < 450 ? (windowSize[0] > 365 ? 365 : windowSize[0]) : 450
      }
    >
      {notif && (
        <div className='mx-4 mb-5'>
          <div className='has-text-centered mb-5 has-text-info'>
            <p className='is-size-5 has-text-semibold'>
              Reset Password Berhasil
            </p>
          </div>
          <p className='is-italic has-text-centered is-size-6 notification is-info is-light'>
            Password telah direset dengan password baru. Cek email untuk detail password baru.
          </p>
        </div>
      )}
      {!notif && (
        <div>
          <div className='has-text-centered mb-5 has-text-info'>
            <p className='is-size-6'>Apakah Anda ingin mereset password?</p>
            <p className='has-text-info is-size-7 is-italic'>
              Isikan password baru untuk mereset password lama:
            </p>
            {isExpired && (
              <p className='has-text-info is-size-7 is-italic mt-4'>
                <span className='tag is-rounded is-danger'>
                  Link has expired
                </span>
              </p>
            )}
          </div>
          <form onSubmit={handleSubmit(handleResetPassword)} autoComplete='off'>
            <Field
              name='username'
              type='text'
              component={LoginTextInput}
              defaultValue={username}
              placeholder='Username'
              autoComplete='new-password'
              label='Username'
              icon='account'
              readOnly={true}
            />
            <Field
              name='newPass'
              type='password'
              autoComplete='new-password1'
              component={LoginTextInput}
              placeholder='Password Baru'
              label='Password Baru'
              icon='lock'
              disabled={isExpired}
            />
            <Field
              name='confirmPass'
              type='password'
              autoComplete='new-password2'
              component={LoginTextInput}
              placeholder='Konfirm Password'
              label='Konfirm Password'
              icon='lock'
              disabled={isExpired}
            />
            <div className='field has-text-centered' style={{ marginTop: 25 }}>
              {error && <p className='help is-danger'>{error}</p>}
              <button
                type='submit'
                disabled={invalid || loading || pristine || isExpired}
                style={{ marginRight: 10 }}
                className={`button is-info is-small is-rounded${
                  loading ? ' is-loading' : ''
                }`}
              >
                Simpan
              </button>
            </div>
          </form>
        </div>
      )}
      <BackToLogin inBackToLogin={handleBackToLogin} />
    </BodyAuth>
  );
}

export default withRouter(
  connect(
    mapState,
    actions
  )(
    reduxForm({
      form: 'formResetPassword',
      onChange: handleOnFormChange,
      validate,
    })(ResetPassword)
  )
);
